<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Attendance</h5>
        </div>
        <!--Export Button-->
            <div class="col-sm-6 col-6 text-right">
            <a-button
              type="primary"
              icon="download"
              :loading="exporting"
              @click="exportAttendanceReport"
            >
              Export Monthly Report
            </a-button>
          </div>
        <div class="col-8 col-sm-6 text-right">

        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row mb-2">
          <!-- Session -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedSession"
              optionFilterProp="children"
              style="width: 100%"
              @change="handleSessionChange"
              :filterOption="false"
              :defaultValue="currentSession ? currentSession.id : ''"
            >
            <template v-for="schoolSession in schoolSessions">
              <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
              </a-select-option>
            </template>
            </a-select>
          </div>
          <!-- Class -->
          <div class="col-md-3 col-12 mb-2">
            <a-spin :spinning="classSpinning">
              <a-select
                size="large"
                v-model="selectedClass"
                placeholder="Select class"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleClassChange"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <template v-for="schoolClass in schoolClasses">
                  <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Section -->
          <div class="col-md-3 col-12 mb-2">
            <a-spin :spinning="sectionSpinning">
              <a-select
                size="large"
                v-model="selectedSection"
                placeholder="Select section"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleSectionChange"
                :filterOption="false"
                :defaultValue="undefined"
                :disabled="!selectedClass"
              >
                <template v-for="section in sections">
                  <a-select-option :value="section.id" :key="section.id">
                  {{section.name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-spin>
          </div>
          <!-- Date -->
          <div class="col-md-3 mb-2">
            <a-date-picker
              size="large"
              style="width: 100%"
              :disabled="!selectedSection"
              :disabledDate="disabledDate"
              v-model="selectedDate"
              @change="handleDateSelect"
              :format=dateFormat />
          </div>

        </div>
        <div class="card">
          <div class="card-body">
            <a-spin :spinning="loading">
              <attendance-table
                :attendanceData="data"
                :errorMessage="errorMessage"
                :attendanceDate="moment(selectedDate).format('YYYY-MM-DD')"
                :additionalData="makeAdditionalData()"
                @submitted="handleAttendanceSubmitted"
                :rolesetting="pagepermission"
              />
            </a-spin>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import AttendanceTable from '@/components/attendance/Table/index'

import { find } from 'lodash'
import moment from 'moment'

export default {
  components: {
    AttendanceTable,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('attendance', 22)
    rc.then(data => {
      console.log('permission data::')
      console.log(data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
      })
      .catch(error => {
        console.log(error)
      })
    this.$http.get('/api/class')
      .then(({ data }) => {
        this.schoolClasses = data.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
      data: null,
      exporting: false,
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      selectedDate: moment(),
      sectionSpinning: false,
      classSpinning: false,
      disabledDates: [],
      errorMessage: '',
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
        approvable: false,
      },
    }
  },
  methods: {
    moment,
    getAttendanceData: function(value) {
      if (this.selectedDate) {
        this.disabledDates = []
        this.errorMessage = ''
        this.loading = true
        this.$http.get('/api/attendance/data', {
          params: {
            class_id: this.selectedClass,
            section_id: this.selectedSection,
            session_id: this.selectedSession,
            date: moment(this.selectedDate).format('YYYY-MM-DD'),
          },
        }).then(({ data }) => {
          this.loading = false
          this.data = data.data

          data.data.holidays.forEach(date => {
            if (!date.in_attendance) {
              this.disabledDates.push(moment(date).format('YYYY-MM-DD'))
            }
          })
        }).catch(error => {
          this.loading = false
          this.data = null
          this.errorMessage = (error && error.message) ? error.message : 'Unauthorized access to this class section.'
        })
      } else {
        this.$message.warning('You need to select a date to view attendance!')
        this.data = null
      }
    },
    exportAttendanceReport() {
      if (!this.selectedClass || !this.selectedSection) {
        this.$message.warning('Please select class and section first.')
        return
      }

      this.exporting = true

      this.$http.get('/api/attendance/report/export/monthly', {
        params: {
          session_id: this.selectedSession,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          date: moment(this.selectedDate).format('YYYY-MM-DD'),
        },
        responseType: 'blob',
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            'Attendance_Report_' + moment(this.selectedDate).format('MMM_YYYY') + '.xlsx'
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('Monthly report exported successfully!')
        })
        .catch(error => {
          console.error(error)
          this.$message.error('Failed to export report!')
        })
        .finally(() => {
          this.exporting = false
        })
    },
    makeAdditionalData() {
      return {
        classId: this.selectedClass,
        sectionId: this.selectedSection,
        sessionId: this.selectedSession,
      }
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          console.log(data.data)
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassChange (value) {
      this.selectedSection = undefined
      this.data = null
      this.errorMessage = ''
      if (value) {
        this.selectedClass = value
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`)
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getAttendanceData()
      } else {
        this.selectedSection = undefined
      }
    },
    handleSessionChange (value) {
      this.errorMessage = ''
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.selectedClass = undefined
      this.selectedSection = undefined
      this.getClasses()
    },
    handleDateSelect (date) {
      this.selectedDate = date
      this.getAttendanceData()
    },
    disabledDate(current) {
      return this.disabledDates.includes(current.format('YYYY-MM-DD')) || current.day() === 0 || current > moment().endOf('day')
    },
    handleAttendanceSubmitted(submittedDate) {
      if (submittedDate) {
        this.selectedDate = moment(submittedDate)
      }
      this.getAttendanceData()
    },
  },
}
</script>
